import React from 'react';
import styled from 'styled-components';
import constants from '../../constants';

const PRIVACY_POLICY_DATA = {
  title: '隱私權政策',
  description: ` 非常歡迎您光臨「${constants.SITE_INFO.title}」（以下簡稱本網站），為了讓您能夠安心使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容：`,
  parts: [
    {
      subtitle: '一、隱私權保護政策的適用範圍',
      description:
        '隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。',
    },
    {
      subtitle: '二、個人資料的蒐集、處理及利用方式',
      description: `當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。\n本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。\n於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。\n為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。\n行使用人資料權利方式：依個人資料保護法第3條規定，您就您的個人資料享有查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用、請求刪除之權利。您可書面郵寄至 「${constants.SITE_INFO.address}」方式行使上述權利，本公司將於收悉您的請求後，儘速處理。`,
    },
    {
      subtitle: '三、資料之保護',
      description:
        '本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。\n如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。',
    },
    {
      subtitle: '四、網站對外的相關連結',
      description:
        '本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。',
    },
    {
      subtitle: '五、與第三人共用個人資料之政策',
      description:
        '本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。\n前項但書之情形包括不限於：\n● 經由您書面同意。\n● 法律明文規定。\n● 為免除您生命、身體、自由或財產上之危險。\n● 與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集著依其揭露方式無從識別特定之當事人。\n● 當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。\n● 有利於您的權益。\n● 本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。',
    },
    {
      subtitle: '六、Cookie之使用',
      description:
        '為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導至網站某些功能無法正常執行 。',
    },
    {
      subtitle: '七、隱私權保護政策之修正',
      description:
        '本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。',
    },
  ],
};

const HOHOKING_PRIVACY_POLICY_DATA = {
  title: '隱私權政策',
  description: ``,
  parts: [
    {
      subtitle: `認知與接受條款`,
      description: (
        <ol>
          <li>
            奕果雲端數位（下稱「本公司」）依據
            <a target="_blank" href="/service-policy">
              <b>〈HoHoKing 好好選使用者條款〉</b>
            </a>
            ，透過本公司經營之網站及應用程式（下稱「本平臺」、「平臺」、「本平台」或「平台」）提供使用者（下稱「您」或「用戶」）本公司之服務。
          </li>
          <li>
            本公司有權於任何時間變更本條款之內容，變更後的本條款自公布在平臺內即行生效。
          </li>
          <li>
            當您完成註冊流程而正式成為本平臺之用戶時，即表示您已閱讀、瞭解並同意接受本條款之一切約定或該等變更後之內容，本條款即行生效，您除須遵守本條款所有規定外，並應遵守本公司對於用戶之其他相關規定。
          </li>
          <li>
            若您對本服務內容有所疑慮，或您無法遵守或不同意本條款之內容，或您所屬的國家或地區排除本條款內容之一部或全部時，請立即停止使用本服務。若您已閱讀、瞭解並同意接受本條款之一切約定或該等變更後之內容，但不同意任一專案服務條款之內容，則不影響其餘專案條款之適用。
          </li>
          <li>
            當您違反本條款之任一規定時，本公司、本公司之關係企業或合作夥伴有權不經通知即暫停或終止您的平臺用戶帳號及使用本服務之全部或部分權利。
          </li>
          <li>
            您瞭解並同意，本公司及平台有權不經事先預告或通知，隨時修改、暫停或永久停止提供服務，本公司、本公司之關係企業或合作夥伴就此不負任何法律責任。
          </li>
        </ol>
      ),
    },
    {
      subtitle: `適用範圍`,
      description: `本政策適用於用戶在使用本平臺或與本平台整合的其他應用程式所涉及之個人資料蒐集。凡經由本平臺連結至第三方所獨立經營管理之網站或應用程式，有關個人資料的蒐集、利用、處理及保護，適用其特別隱私權政策，本公司及本平台不負任何連帶責任。
    `,
    },
    {
      subtitle: `個人資料之蒐集目的`,
      description: `本公司及平台蒐集用戶個人資料之目的，在於增進用戶體驗及協助本平台及合作方提供更好之服務品質。\n`,
    },
    {
      subtitle: `個人資料之蒐集類別`,
      description: (
        <>
          本平台蒐集的個人資料包含以下範圍：
          <ol>
            <li>個人資訊：如會員姓名及地址</li>
            <li>訂單資訊：如會員購買之商品及數量</li>
            <li>瀏覽行為：如會員於平台點擊商品之情形</li>
            <li>廣告行銷：如會員點擊平台上廣告之相關資訊</li>
            <li>客服資訊：如會員與本平台因訂單而產生之互動溝通內容</li>
          </ol>
        </>
      ),
    },
    {
      subtitle: `個人資料之蒐集方式`,
      description: (
        <>
          本平台將透過以下方式，蒐集上述的用戶個人資料：
          <ol>
            <li>用戶註冊</li>
            <li>平台瀏覽及購物</li>
            <li>用戶參與與本平台合作之第三方之活動時（如抽獎）</li>
            <li>客服處理</li>
            <li>其他</li>
          </ol>
        </>
      ),
    },
    {
      subtitle: `個人資料之運用`,
      description: (
        <>
          本平台所蒐集的足以識別您身分的個人資料將以下列方式進行利用：
          <ol>
            <li>廣告行銷：提供會員訊息通知及商品或活動相關資訊</li>
            <li>
              商品配送：為了將您所訂購的商品順利送達至您所指定的收件地點，本平台將會把您所提供的個人資料提供予合作夥伴，如物流業者。
            </li>
            <li>
              金融交易授權：
              為完成訂單付款作業流程，本平台將於交易過程中將您所提供得識別財務之資料提供予必要之相關金融機構。
            </li>
            <li>
              其他業務附隨事項：
              為了完成上述目的，包括但不限於客戶管理與服務、履行法定或合約義務、保護當事人及相關利害關係人之權益、財產保險、責任保險、提供售後服務等，本平台將在必要的範圍內，以符合個人資料保護法規定的方式利用您所提供的個人資料。
            </li>
            <li>
              市場分析：
              為了提升服務品質，依照您在的瀏覽活動（例如：使用者所使用的軟硬體、所點選的網頁等）、以及行動應用程式之使用紀錄等資料，本平台將會把這些資料及記錄用於流量分析和網路行為調查，包含透過第三方使用cookie或類似技術，以便於改善相關網站與行動應用程式的服務品質。
            </li>
          </ol>
        </>
      ),
    },
    {
      subtitle: `個人資料利用期間、地區、對象`,
      description: (
        <ol>
          <li>
            利用期間：
            本平台將依照本隱私權聲明所載之個人資料蒐集的特定目的，於營業存續期間、個別合約有效期間內、法令所定應保存之期間內（包括但不限於民法、個人資料保護法等）及因執行業務所須之保存期間內（較法令所定期間更長者），持續保管、處理及利用所蒐集之個人資料。
          </li>
          <li>
            利用地區：除法令另有規定外，本平台僅會基於您授權的範圍，於平台服務所提供之領域及地區內，依照各該服務目的範圍為作業之必要，利用您所提供的個人資料。
          </li>
          <li>
            利用對象：本平台將自行利用、於平台之關係企業間分享及交互運用、或依照提供予您的各該服務或所參加活動所須之範圍內，將您的個人資料提供予必要的相關合作夥伴。
          </li>
        </ol>
      ),
    },
    {
      subtitle: `個人資料的自主權`,
      description: `會員對於其個人資料，有查詢及閱覽、補充或更正、停止電腦處理及利用、刪除等權利。如有需求可與客服聯絡，平台獲知後將儘速處理。`,
    },
    {
      subtitle: `Cookie`,
      description: `Cookie 為了便利使用者，本平台可能使用cookie技術以便於提供更適合使用者個人需要的服務；cookie是網站伺服器用來和使用者瀏覽器進行溝通的一種技術，它可能在使用者的電腦中儲存某些資訊，本平台也會讀取儲存在使用者電腦中的cookie資料。使用者可以經由瀏覽器的設定，取消、或限制此項功能，但可能因此無法使用部份網站功能。`,
    },
    {
      subtitle: `個人資料的安全保護`,
      description: `為保護用戶的隱私，本公司將以合於產業標準之合理技術及程序，維護個人資料之安全。`,
    },
  ],
};

function PrivacyPolicy(props) {
  return (
    <Wrapper id="rev-PrivacyPolicyPage">
      <div className="container">
        <div>
          <div className="title-section">
            <h1>{HOHOKING_PRIVACY_POLICY_DATA.title}</h1>
            <p>{HOHOKING_PRIVACY_POLICY_DATA.description}</p>
          </div>

          {HOHOKING_PRIVACY_POLICY_DATA.parts.map((part, index) => (
            <div className="section" key={`privacy-policy-parts-${index}`}>
              <h2>{part.subtitle}</h2>
              <p>{part.description}</p>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  & > .container {
    max-width: var(--contentMaxWidth);
    min-height: var(--contentMinHeight);

    margin: 0 auto;
    padding-top: var(--topNavBarHeight);
    padding-bottom: 20px;

    & .title-section {
      padding: 25px 20px 10px 20px;
    }

    & .section {
      padding: 10px 20px;
    }

    & h1,
    h2 {
      margin-bottom: 15px;
      color: var(--primaryColor);
    }

    & p {
      white-space: pre-wrap;
      line-height: 2rem;
      font-size: 1rem;
    }
  }
`;

export default PrivacyPolicy;
